<template>
  <section class="section-filters">
    <PhonesFiltersSelected />
    <div class="filters-list">
      <PhonesFiltersDropdowns />
      <PhonesFiltersDate />
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import PhonesFiltersSelected from "./PhonesFiltersSelected.vue";
import PhonesFiltersDropdowns from "./PhonesFiltersDropdowns.vue";
import PhonesFiltersDate from "./PhonesFiltersDate.vue";

@Component({
  components: {
    PhonesFiltersSelected,
    PhonesFiltersDropdowns,
    PhonesFiltersDate,
  },
})
export default class PhonesFilters extends Vue {
  PhonesFilter1SelectedOptions = [1, 2];
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.section-filters {
  .filters-list {
    display: flex;
    flex-wrap: wrap;
    padding: 25px 0 5px;
    margin: 0 -12px;
    @media (max-width: 991px) {
      margin: 0 -8px;
    }
  }

  .dropdown-w {
  }
}
</style>
